var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(0 0.5)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66659 2.33325C4.44492 2.33325 1.83325 4.94492 1.83325 8.16659C1.83325 11.3882 4.44492 13.9999 7.66659 13.9999C10.8882 13.9999 13.4999 11.3882 13.4999 8.16659C13.4999 4.94492 10.8882 2.33325 7.66659 2.33325ZM0.833252 8.16659C0.833252 4.39264 3.89264 1.33325 7.66659 1.33325C11.4405 1.33325 14.4999 4.39264 14.4999 8.16659C14.4999 11.9405 11.4405 14.9999 7.66659 14.9999C3.89264 14.9999 0.833252 11.9405 0.833252 8.16659Z",
    fill: "#282828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9797 13.4797C13.175 13.2844 13.4915 13.2844 13.6868 13.4797L15.0201 14.813C15.2154 15.0083 15.2154 15.3249 15.0201 15.5201C14.8249 15.7154 14.5083 15.7154 14.313 15.5201L12.9797 14.1868C12.7844 13.9915 12.7844 13.675 12.9797 13.4797Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3b0d2c9bd0ff108d0fa156e2b4a74420.svg";
export { ForwardRef as ReactComponent };